
import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/components/AuthProvider";
import { LoginForm } from "@/components/auth/LoginForm";
import { SignupForm } from "@/components/auth/SignupForm";
import { PasswordResetForm } from "@/components/auth/PasswordResetForm";
import { useLanguage } from "@/components/LanguageContext";
import { useLanguagePath } from "@/utils/language";

type FormType = "login" | "signup" | "reset";

const Auth = () => {
  const [formType, setFormType] = useState<FormType>("login");
  const { user, profile } = useAuth();
  const { t } = useLanguage();
  const { getPath } = useLanguagePath();

  if (user && profile) {
    // Se o perfil não está completo, redirecionar para completar
    if (!profile.is_onboarded) {
      return <Navigate to={getPath("/complete-profile")} replace />;
    }
    // Redirecionar baseado no tipo de utilizador
    if (profile.is_student && !profile.is_trainer) {
      return <Navigate to={getPath("/student-dashboard")} replace />;
    } else if (profile.is_trainer && !profile.is_student) {
      return <Navigate to={getPath("/dashboard")} replace />;
    } else {
      return <Navigate to={getPath("/dashboard")} replace />;
    }
  }

  const toggleForm = (type: FormType) => setFormType(type);

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-secondary/20 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center p-4">
      <div className="w-full max-w-md space-y-8 bg-white dark:bg-gray-800/90 p-8 rounded-lg shadow-lg dark:border dark:border-gray-700/50">
        {formType === "login" && (
          <LoginForm 
            onToggleForm={() => toggleForm("signup")} 
            onForgotPassword={() => toggleForm("reset")}
          />
        )}
        {formType === "signup" && (
          <SignupForm 
            onToggleForm={() => toggleForm("login")} 
          />
        )}
        {formType === "reset" && (
          <PasswordResetForm 
            onBackToLogin={() => toggleForm("login")} 
          />
        )}
      </div>
    </div>
  );
};

export default Auth;
